// DEMO DATA. Replaced by a live data context in the next phase.
// Remove before production release.

import type { KpiAudience } from "./KpiStrip";
import type { KpiMetricValue } from "./kpiTypes";

export const KPI_DEMO_DATA_ACTIVE = true;

export const KPI_DEMO_DATA: Record<KpiAudience, KpiMetricValue[]> = {
    student: [
        { id: "served", value: 1351 },
        { id: "services", value: 5155 },
        { id: "hours", value: 2850.6 },
        { id: "avgHours", value: 2.11 },
        { id: "avgSessions", value: 3.82 },
        { id: "noServices", value: 214 },
    ],
    parent: [
        { id: "served", value: 412 },
        { id: "services", value: 968 },
        { id: "hours", value: 618.0 },
        { id: "avgHours", value: 1.5 },
        { id: "avgSessions", value: 2.35 },
        { id: "noServices", value: 89 },
    ],
};
